import {
    ChangeDetectionStrategy,
    Component,
    forwardRef,
    inject,
    input,
    output,
    signal
} from '@angular/core';
import {
    NG_VALUE_ACCESSOR,
    NG_VALIDATORS,
    ControlContainer,
    FormGroupDirective,
    FormsModule,
    ReactiveFormsModule,
    FormGroup
} from '@angular/forms';
import { ZSelectComponent } from '../../../../../shared/components/form-components/z-select/z-select.component';
import { ZDatePickerComponent } from '../../../../../shared/components/form-components/z-date-picker/z-date-picker.component';
import {
    CustomerType,
    InvoiceType,
    InvoiceTypeFormGroup
} from '@shared/zigra-schemas/zigra-schema.autogenerated.models';
import { ZAadeInvoiceTypeComponent } from '../z-aade-invoice-type/z-aade-invoice-type.component';
import { FieldsetModule } from 'primeng/fieldset';
import {
    IAADEInvoicePaymentType,
    ZAadeInvoicePaymentComponent
} from '../z-aade-invoice-payment/z-aade-invoice-payment.component';
import { SelectModule } from 'primeng/select';
import { ZFloatLabelComponent } from '@shared/components/form-components/z-float-label/z-float-label.component';
import { ZCustomerSelectComponent } from '@shared/components/bussiness-components/z-customer-select/z-customer-select.component';
import { InvoiceCardCustomerComponent } from '../invoice-card-customer/invoice-card-customer/invoice-card-customer.component';
import { ZInvoiceSeriesInfoComponent } from '../z-invoice-series-info/z-invoice-series-info.component';
import { ZCheckboxComponent } from '@shared/components/form-components/z-checkbox/z-checkbox.component';
import { ZInvoiceMovePurposesComponent } from '@shared/components/bussiness-components/z-invoice-move-purposes/z-invoice-move-purposes.component';
import { CheckboxChangeEvent } from 'primeng/checkbox';

@Component({
    selector: 'z-invoice-card-header-info',
    imports: [
        FormsModule,
        ReactiveFormsModule,
        ZDatePickerComponent,
        ZAadeInvoiceTypeComponent,
        FieldsetModule,
        SelectModule,
        ZAadeInvoicePaymentComponent,
        ZFloatLabelComponent,
        ZCustomerSelectComponent,
        InvoiceCardCustomerComponent,
        ZInvoiceSeriesInfoComponent,
        ZCheckboxComponent,
        ZInvoiceMovePurposesComponent
    ],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => InvoiceCardHeaderInfoComponent),
            multi: true
        },
        {
            provide: NG_VALIDATORS,
            multi: true,
            useExisting: InvoiceCardHeaderInfoComponent
        }
    ],
    viewProviders: [
        {
            provide: ControlContainer,
            useExisting: FormGroupDirective
        }
    ],
    templateUrl: './invoice-card-header-info.component.html',
    styleUrl: './invoice-card-header-info.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class InvoiceCardHeaderInfoComponent {
    private rootFormGroup = inject(FormGroupDirective);
    invoice?: InvoiceType;

    disableCustomer = input<boolean | undefined>();
    selectedCustomer = input<CustomerType | undefined>();
    invoiceTypeCode = input<string | null | undefined>();
    isDeliveryNote = input<boolean | null | undefined>();
    customerSelected = output<{
        customerType: CustomerType | undefined;
        rowIndex?: number;
    }>();

    // options = signal<any>([
    //     {
    //         _id: 3,
    //         Type: '3',
    //         Title: 'Μετρητά'
    //     } as IAADEInvoicePaymentType,
    //     {
    //         _id: 5,
    //         Type: '5',
    //         Title: 'Επί Πιστώσει'
    //     } as IAADEInvoicePaymentType,
    //     {
    //         _id: 7,
    //         Type: '7',
    //         Title: 'POS / e-POS'
    //     } as IAADEInvoicePaymentType,
    //     {
    //         _id: 8,
    //         Type: '7',
    //         Title: 'IRIS'
    //     } as IAADEInvoicePaymentType
    // ]);

    formGroup?: InvoiceTypeFormGroup;

    constructor() {
        // this.invoice?.Response?.InvoiceMark;
        //this.invoice?.Payments?.[0]?.Type
        //this.invoice?.TypeCode
        // this.invoice?.Customer?.SureName
        // this.invoice?.Customer?.FirstName
        // this.invoice?.Customer?.ContactDetails?.[0]?.EMail
        // this.invoice?.Customer?.ContactDetails?.[0]?.Mobile
    }

    ngOnInit() {
        console.debug(
            'invoice-card-header-info: ',
            this.rootFormGroup.form.getRawValue()?._id
        );

        this.formGroup = this.rootFormGroup.form as any;
    }

    isDeliveryNoteValueChange(event: CheckboxChangeEvent) {
        console.debug(event);
        if (event.checked == true) {
            const movePurpose = this.formGroup?.controls.MovePurpose?.value;
            if (movePurpose == undefined)
                this.formGroup?.controls.MovePurpose?.setValue(1);
        }
    }
}
